var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "progress-bar-container"
  }, [_c('div', {
    staticClass: "container-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col d-flex align-items-center"
  }, [_vm.$slots.header ? _c('div', {
    staticClass: "progress-bar-container__text"
  }, [_vm._t("header")], 2) : _vm._e(), _vm.$slots.bar ? _c('div', {
    staticClass: "progress-bar-container__bar"
  }, [_vm._t("bar")], 2) : _vm._e()])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }